import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=29b1235b&"
import script from "./Callout.vue?vue&type=script&lang=js&"
export * from "./Callout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Callout.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Callout.vue
// module id = null
// module chunks = 